<template>
  <el-dialog :title="$t('businessDatabusManage.edit')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="editBusinessDatabusInfo" label-width="120px" label-position="right">
      <el-form-item :label="$t('businessDatabusManage.name')" prop="databusName" :rules="[
        { required: true, message: $t('businessDatabusManage.nameRequired'), trigger: 'blur' },
        { max: 128, message: $t('businessDatabusManage.nameTooLong'), trigger: 'blur' }
      ]">
        <el-input v-model="editBusinessDatabusInfo.databusName" :placeholder="$t('businessDatabusManage.inputName')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.businessType')" prop="businessTypeCd" :rules="[
        { required: true, message: $t('businessDatabusManage.businessTypeRequired'), trigger: 'blur' }
      ]">
        <el-input v-model="editBusinessDatabusInfo.businessTypeCd"
          :placeholder="$t('businessDatabusManage.inputBusinessType')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.adapter')" prop="beanName" :rules="[
        { required: true, message: $t('businessDatabusManage.adapterRequired'), trigger: 'blur' },
        { max: 256, message: $t('businessDatabusManage.adapterTooLong'), trigger: 'blur' }
      ]">
        <el-input v-model="editBusinessDatabusInfo.beanName" :placeholder="$t('businessDatabusManage.inputAdapter')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.seq')" prop="seq" :rules="[
        { required: true, message: $t('businessDatabusManage.seqRequired'), trigger: 'blur' }]">
        <el-input v-model.number="editBusinessDatabusInfo.seq" :placeholder="$t('businessDatabusManage.inputSeq')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.status')" prop="state" :rules="[
        { required: true, message: $t('businessDatabusManage.statusRequired'), trigger: 'change' }
      ]">
        <el-select v-model="editBusinessDatabusInfo.state" :placeholder="$t('businessDatabusManage.selectStatus')"
          style="width:100%">
          <el-option :label="$t('businessDatabusManage.inUse')" value="1001" />
          <el-option :label="$t('businessDatabusManage.disabled')" value="2002" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('businessDatabusManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="editBusinessDatabus">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateBusinessDatabus } from '@/api/dev/businessDatabusApi'

export default {
  name: 'EditBusinessDatabus',
  data() {
    return {
      dialogVisible: false,
      editBusinessDatabusInfo: {
        databusId: '',
        databusName: '',
        businessTypeCd: '',
        beanName: '',
        seq: '',
        state: ''
      }
    }
  },
  methods: {
    open(row) {
      this.editBusinessDatabusInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async editBusinessDatabus() {
      try {
        await this.$refs.form.validate()
        await updateBusinessDatabus(this.editBusinessDatabusInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('businessDatabusManage.editSuccess'))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>